import {useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import InstrumentIcon from "../../../../components/instrument-icon";
import {useTranslation} from "react-i18next";
import FormButton from "../../../../components/form-button";
import Big from "big.js";
import {toast} from "react-toastify";
import associateServices from "../../../../services";
import MATH_HELPER from "../../../../helpers/math-helper";
import FromCurrenciesDropdown from "./from-currencies";
import {decrypt, encrypt} from "../../../../helpers/encryption";
import BuyCryptoTargetDropdown from "./target-dropdown";

const BuyCryptoModal = props => {
    const {
        currencyList,
        currencies,
        selectedWallet,
        selectedFiat,
        // wallets
    } = useSelector(state => state.authenticationReducer)

    const [currencyListFiltered, setCurrencyListFiltered] = useState([])
    useEffect(() => {
        setCurrencyListFiltered(currencyList?.filter(pp => ['ETH', 'BTC', 'USDT', 'BNB', 'ADA', 'LINK', 'DOGE']?.includes(pp?.code)))
    }, [currencyList])
    const {
        modalCurrency,
        agent
    } = useSelector(state => state.globalReducer)
    const [rates, setRates] = useState({})
    const [loading, setLoading] = useState(false)
    const {t} = useTranslation()
    const [data, setData] = useState({})
    const [fromCurrency, setFromCurrency] = useState({
        code: 'USD'
    })
    const [targetCurrency, setTargetCurrency] = useState({})

    const [instance, setInstance] = useState({
        amount: '100',
    })

    // const tt = {
    //     'buy-crypto': {
    //         "amount": "Amount",
    //         "result-in-currency": "Estimated Amount to Get",
    //         "result": "Result",
    //         "buy": "Buy"
    //     }
    // }
    useEffect(() => {
        if (selectedFiat) {
            const handleFiatRates = e => {
                const data = decrypt(e)
                setRates(data)
            }
            window?.tcpSocket?.emit('fiat:rate', encrypt({
                currency: selectedFiat
            }))

            window?.tcpSocket?.on('fiat:rates', handleFiatRates)
        }
    }, [selectedFiat])

    useEffect(() => {
        const handler = setTimeout(() => {
            if (fromCurrency?.code && targetCurrency?.code && instance?.amount) {
                const body = {
                    from: fromCurrency?.code,
                    to: targetCurrency?.code,
                    amount: instance.amount,
                };
                associateServices.getSwapResults(body).then((res) => {
                    setData(res?.data || {});
                });
            }
        }, 400); // Adjust the delay to 400-500 ms

        // Cleanup function to cancel the timeout if dependencies change
        return () => clearTimeout(handler);

    }, [targetCurrency?.code, fromCurrency?.code, instance.amount])


    useEffect(() => {
        if (modalCurrency) {
            const targetWallet = currencyListFiltered.find(i => i.code !== modalCurrency)
            setTargetCurrency(targetWallet)
        } else if (selectedWallet?.code) {
            const targetWallet = currencyListFiltered.find(i => i.code === selectedWallet?.code)
            if (targetWallet)
                setTargetCurrency(targetWallet)
            else
                setTargetCurrency(currencyListFiltered[0])
        }
    }, [selectedWallet, modalCurrency, currencyListFiltered])


    const handleBuyCrypto = () => {
        if (loading)
            return false;

        let amount = instance.amount
        if (selectedFiat)
            amount = Big(instance.amount || 0).times(rates[fromCurrency?.code] || 0).toFixed(8)


        const body = {
            ...instance,
            from: fromCurrency.code,
            to: targetCurrency.code,
            amount
        }
        body.amount = body?.amount?.replace(/,/g, '.')

        if (!MATH_HELPER.isNumeric(body.amount))
            return toast.error(t(`general.enter-a-valid-amount`))

        setLoading(true)

        associateServices.buyCrypto(body).then(res => {

            setLoading(false)

            if (res?.errors)
                toast.error(t(`api-notifications.${res?.errors}`))


            if (res?.data?.url) {
                try {
                    if (agent?.isMobile)
                        window.location.href = res?.data?.url;
                    else
                        window.open(res?.data?.url, '_blank')
                } catch (e) {
                    window.location.href = res?.data?.url;
                }
                setLoading(false)
            }
        })


    }
    const [regex] = useState(new RegExp("^\\d{1,8}(\\.\\d{0," + 8 + "})?$"))

    const handleChange = (type, value) => {
        if (type === 'amount') {
            if (value === '' || regex.test(value)) {
                setInstance(prevState => ({
                    ...prevState,
                    [type]: value
                }))
            }
        } else
            setInstance(prevState => ({
                ...prevState,
                [type]: value
            }))
    }
    const handleChangeWallet = wall => {
        setFromCurrency(wall)
    }
    const handleChangeWalletTarget = wall => {

        console.log('currencyListFiltered = ', wall)
        if (wall.code === targetCurrency?.code)
            return true


        const instances = currencies?.filter(ioi => ioi.alias === wall?.code)

        if (instances)
            setTargetCurrency(wall)

    }

    const getDisplayCurrency = () => {
        if (!selectedFiat)
            return `${Big(instance?.amount || 0).toFixed(8)} ${fromCurrency?.code}`

        return `${Big(instance.amount || 0).times(rates[fromCurrency?.code] || 0).toFixed(8)} ${fromCurrency?.code}`
    }

    return (

        <>
            <div className="modal__drops gap-2">
                <FromCurrenciesDropdown
                    handleChangeWallet={handleChangeWallet}
                    selectedCurrency={fromCurrency}/>
                <div className="d-flex flex-column justify-content-center  dropdown" style={{
                    marginTop: 54
                }}>
                    <span>→</span>
                </div>
                <BuyCryptoTargetDropdown currencyList={currencyListFiltered}
                                         handleChangeWallet={handleChangeWalletTarget}
                                         selectedCurrency={targetCurrency}/>

            </div>

            <div className="modal__form">

                <div className="form__group">
                    <label htmlFor="" className="form__label form__label--max">
                        {t('buy-crypto.amount-placeholder', {
                            code: targetCurrency?.code
                        })} <b>*</b>
                        <span>
                            {getDisplayCurrency()}
                        </span>
                    </label>
                    <div className="form__amount">
                        <input
                            pattern="[0-9]*"
                            inputMode="numeric"
                            value={instance.amount}
                            onChange={e => handleChange('amount', e.target.value)}
                            type="text" className="form__input"/>

                        <div className="form__coin">
                            <InstrumentIcon code={selectedFiat || fromCurrency?.code}/>
                        </div>
                        <button className="form__max" type="button"
                            // onClick={handleSetMax}
                        >
                            {t('buy-crypto.amount')}
                        </button>
                    </div>
                </div>
                <div className="form__group">
                    <label htmlFor="" className="form__label">
                        {t('buy-crypto.result-in-currency', {
                            code: fromCurrency?.code
                        })} <b>*</b>
                    </label>

                    <div className="form__amount">
                        <input
                            pattern="[0-9]*"
                            inputMode="numeric"
                            value={data?.result || ''}
                            type="text" className="form__input"/>

                        <div className="form__coin">
                            <InstrumentIcon code={targetCurrency?.code}/>
                        </div>
                        <button className="form__max" type="button" disabled>
                            {t('buy-crypto.result')}
                        </button>
                    </div>


                </div>


                <FormButton onClick={handleBuyCrypto}
                            label={t('buy-crypto.buy')}
                            disabled={loading}
                            loading={loading}
                />


                <div className="row w-100 align-items-center justify-content-center">


                    <>
                        <img src="https://cdn.ebetlab.com/master-card.svg"
                             style={{
                                 width: 100,
                                 alignSelf: 'center',
                                 padding: 12,
                                 objectFit: 'contain'
                             }}
                             alt=""/>


                        <img src="https://cdn.ebetlab.com/visa.svg"
                             style={{
                                 width: 100,
                                 alignSelf: 'center',
                                 padding: 12,
                                 objectFit: 'contain'
                             }}
                             alt=""/>
                    </>


                </div>


            </div>

        </>
    )

}


export default BuyCryptoModal
